import React from 'react';
import { TopBar } from '@/components/TopBar';
import { Page } from '@/components/Page';
import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { money } from '@/lib/helpers';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';

export default function Reports() {
  const { data: trend = [] } = useQuery({ queryKey: ['trend'], queryFn: async () => (await api.get('/reports/sales-trend', { params: { days: 7 } })).data.data });
  const { data: dash } = useQuery({ queryKey: ['dashboard'], queryFn: async () => (await api.get('/reports/dashboard')).data.data });
  return (
    <Page>
      <TopBar title="Reports" />
      <div className="px-4 pt-4 space-y-4">
        <div className="rounded-2xl border border-border bg-card p-4">
          <p className="mb-3 text-sm font-semibold">Sales - last 7 days</p>
          <div className="h-52">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={trend} margin={{ left: -10, right: 8, top: 8 }}>
                <XAxis dataKey="date" tick={{ fontSize: 11 }} stroke="#94a3b8" />
                <YAxis tick={{ fontSize: 11 }} stroke="#94a3b8" />
                <Tooltip formatter={(v) => money(v)} />
                <Line type="monotone" dataKey="total" stroke="hsl(174 78% 26%)" strokeWidth={2.5} dot={false} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="rounded-2xl border border-border bg-card p-4">
          <p className="mb-3 text-sm font-semibold">Bills per day</p>
          <div className="h-44">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={trend} margin={{ left: -20, right: 8, top: 8 }}>
                <XAxis dataKey="date" tick={{ fontSize: 11 }} stroke="#94a3b8" />
                <YAxis tick={{ fontSize: 11 }} stroke="#94a3b8" allowDecimals={false} />
                <Tooltip />
                <Bar dataKey="bills" fill="hsl(43 60% 55%)" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        {dash && (
          <div className="grid grid-cols-2 gap-3">
            {dash.store_stock?.map((s) => (
              <div key={s.store_id} className="rounded-2xl border border-border bg-card p-4"><p className="text-xs text-muted-foreground">{s.store_name}</p><p className="font-mono text-xl font-semibold">{money(s.sales_today)}</p><p className="text-xs text-muted-foreground">{s.available} in stock</p></div>
            ))}
            <div className="rounded-2xl border border-border bg-card p-4"><p className="text-xs text-muted-foreground">Outstanding Credit</p><p className="font-mono text-xl font-semibold">{money(dash.outstanding_credit)}</p></div>
            <div className="rounded-2xl border border-border bg-card p-4"><p className="text-xs text-muted-foreground">Pending Transfers</p><p className="font-mono text-xl font-semibold">{dash.pending_transfers}</p></div>
          </div>
        )}
      </div>
    </Page>
  );
}
